import { FC, useEffect } from "preact/compat";
import { useLocation } from "react-router-dom";
import { local } from "~/core/local";
import { useApp } from "~/core/store";
import { uniq } from "~/utils";

const IGNORE_PATTERNS = [/\/.+\/.+\/me/, /\/.+\/.+\/me\/admin/];

// @LINK @DEP layouts/Redirect depends on this data
const localVisits = local<{
    freq: Record<string, number>;
    last: [string, string][];
}>(
    "v1_app_visits",
    {
        freq: {},
        last: [],
    },
    (value) => {
        if (!value.freq) {
            value.freq = {};
        }

        if (!value.last) {
            value.last = [];
        }

        return value;
    },
);

const Visits: FC = () => {
    const { meta } = useApp();
    const { pathname } = useLocation();

    useEffect(() => {
        if (IGNORE_PATTERNS.some((pattern) => pattern.test(pathname))) {
            return;
        }

        const freq = localVisits.get()?.freq ?? {};
        const last = localVisits.get()?.last ?? [];

        if (!(pathname in freq)) {
            freq[pathname] = 0;
        }

        last.unshift([pathname, meta.title.value]);
        ++freq[pathname];

        localVisits.set({
            freq,
            last: uniq(last).slice(0, 3),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return null;
};

export default Visits;
